/* lesamis-pdp.js — logica de la ficha de producto.
   Sin dependencias. Todos los textos visibles llegan por data-* desde Liquid,
   para que sigan pasando por el sistema de traduccion del tema. */
(function () {
  'use strict';

  function initProduct(root) {
    if (root.dataset.pdpReady === 'true') return;
    root.dataset.pdpReady = 'true';

    var sectionId = root.dataset.sectionId;

    var strings = {
      inStock: root.dataset.strInStock || '',
      outStock: root.dataset.strOutStock || '',
      soldOut: root.dataset.strSoldOut || '',
      addToCart: root.dataset.strAddToCart || '',
      unavailable: root.dataset.strUnavailable || '',
      imageOf: root.dataset.strImageOf || ''
    };

    /* ---------- Datos de variantes ----------
       El bloque JSON se imprime fuera de <section>, asi que se busca primero
       por data-for y solo despues dentro del root. */
    var variants = [];
    var dataTag = document.querySelector('[data-variant-data][data-for="' + sectionId + '"]')
      || root.querySelector('[data-variant-data]')
      || document.querySelector('[data-variant-data]');
    if (dataTag) {
      try { variants = JSON.parse(dataTag.textContent) || []; } catch (e) { variants = []; }
    }

    var optionInputs = Array.prototype.slice.call(root.querySelectorAll('[data-option-input]'));
    var variantIdField = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var badgeEl = root.querySelector('[data-badge]');
    var stockEl = root.querySelector('[data-stock]');
    var addButton = root.querySelector('[data-add-button]');
    var stickyPrice = document.querySelector('[data-sticky-price]');

    function selectedOptions() {
      var values = [];
      optionInputs.forEach(function (input) {
        if (!input.checked) return;
        values[parseInt(input.dataset.optionIndex, 10)] = input.value;
      });
      return values;
    }

    function findVariant(values) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < values.length; j++) {
          if (v.options[j] !== values[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    /* Marca combinaciones inexistentes o agotadas sin bloquearlas:
       el cliente sigue explorando y ve por que no puede comprar. */
    function markAvailability() {
      var current = selectedOptions();
      optionInputs.forEach(function (input) {
        var idx = parseInt(input.dataset.optionIndex, 10);
        var probe = current.slice();
        probe[idx] = input.value;
        var found = null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var ok = true;
          for (var j = 0; j < probe.length; j++) {
            if (probe[j] === undefined) continue;
            if (v.options[j] !== probe[j]) { ok = false; break; }
          }
          if (ok) { found = v; break; }
        }
        input.dataset.unavailable = (!found || !found.available) ? 'true' : 'false';
      });
    }

    function updateGalleryForVariant(variant) {
      if (!variant || !variant.media_id) return;
      var slide = root.querySelector('[data-gallery-slide][data-media-id="' + variant.media_id + '"]');
      if (slide && typeof slide.scrollIntoView === 'function') {
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    function applyVariant(variant) {
      if (!variant) {
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = strings.unavailable;
        }
        if (stockEl) {
          stockEl.textContent = strings.unavailable;
          stockEl.setAttribute('data-state', 'out');
        }
        return;
      }

      if (variantIdField) variantIdField.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price_formatted;

      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        compareEl.textContent = onSale ? variant.compare_formatted : '';
        compareEl.hidden = !onSale;
      }
      if (badgeEl) badgeEl.hidden = !onSale;

      if (stockEl) {
        stockEl.textContent = variant.available ? strings.inStock : strings.outStock;
        stockEl.setAttribute('data-state', variant.available ? 'in' : 'out');
      }
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? strings.addToCart : strings.soldOut;
      }
      if (stickyPrice) stickyPrice.textContent = variant.price_formatted;

      updateGalleryForVariant(variant);

      if (window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        markAvailability();
        applyVariant(findVariant(selectedOptions()));
      });
    });

    if (optionInputs.length) {
      markAvailability();
      applyVariant(findVariant(selectedOptions()));
    }

    /* ---------- Galeria ---------- */
    var viewport = root.querySelector('[data-gallery-viewport]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    var counter = root.querySelector('[data-gallery-counter]');
    var activeIndex = 0;

    function setActive(index) {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      thumbs.forEach(function (thumb, i) {
        var on = i === activeIndex;
        thumb.classList.toggle('is-active', on);
        thumb.setAttribute('aria-current', on ? 'true' : 'false');
      });
      if (counter && strings.imageOf) {
        counter.textContent = strings.imageOf
          .replace('{{current}}', activeIndex + 1)
          .replace('{{total}}', slides.length);
      }
    }

    function scrollToSlide(index) {
      if (!viewport || !slides[index]) return;
      viewport.scrollTo({ left: slides[index].offsetLeft - viewport.offsetLeft, behavior: 'smooth' });
    }

    if (viewport && slides.length) {
      var ticking = false;
      viewport.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var center = viewport.scrollLeft + viewport.clientWidth / 2;
          var best = 0;
          var bestDist = Infinity;
          slides.forEach(function (slide, i) {
            var slideCenter = slide.offsetLeft - viewport.offsetLeft + slide.clientWidth / 2;
            var dist = Math.abs(slideCenter - center);
            if (dist < bestDist) { bestDist = dist; best = i; }
          });
          if (best !== activeIndex) setActive(best);
          ticking = false;
        });
      }, { passive: true });

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { scrollToSlide(i); setActive(i); });
      });

      var prev = root.querySelector('[data-gallery-prev]');
      var next = root.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { scrollToSlide(activeIndex - 1); });
      if (next) next.addEventListener('click', function () { scrollToSlide(activeIndex + 1); });

      setActive(0);
    }

    /* ---------- Zoom: se construye bajo demanda, no duplica imagenes en el DOM ---------- */
    var zoomDialog = document.querySelector('[data-zoom-dialog][data-for="' + sectionId + '"]');
    var zoomImage = zoomDialog ? zoomDialog.querySelector('[data-zoom-image]') : null;

    root.querySelectorAll('[data-zoom-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!zoomDialog || !zoomImage) return;
        var slideImg = slides[activeIndex] ? slides[activeIndex].querySelector('img') : null;
        if (!slideImg) return;
        zoomImage.src = slideImg.dataset.zoomSrc || slideImg.currentSrc || slideImg.src;
        zoomImage.alt = slideImg.alt || '';
        if (typeof zoomDialog.showModal === 'function') zoomDialog.showModal();
      });
    });

    /* ---------- Guia de tallas ---------- */
    var guideDialog = document.querySelector('[data-sizeguide-dialog][data-for="' + sectionId + '"]');
    root.querySelectorAll('[data-sizeguide-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (guideDialog && typeof guideDialog.showModal === 'function') guideDialog.showModal();
      });
    });

    [zoomDialog, guideDialog].forEach(function (dialog) {
      if (!dialog) return;
      dialog.querySelectorAll('[data-dialog-close]').forEach(function (button) {
        button.addEventListener('click', function () { dialog.close(); });
      });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
    });

    /* ---------- Cantidad ---------- */
    var qtyInput = root.querySelector('[data-quantity-input]');
    var qtyMinus = root.querySelector('[data-quantity-minus]');
    var qtyPlus = root.querySelector('[data-quantity-plus]');
    if (qtyMinus) qtyMinus.addEventListener('click', function () {
      if (!qtyInput) return;
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
    });
    if (qtyPlus) qtyPlus.addEventListener('click', function () {
      if (!qtyInput) return;
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
    });

    /* ---------- CTA sticky en movil ---------- */
    var stickyBar = document.querySelector('[data-sticky-buy]');
    var stickyAdd = document.querySelector('[data-sticky-add]');
    var buyBlock = root.querySelector('[data-buy-block]');

    if (stickyBar && buyBlock && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { rootMargin: '0px 0px -20% 0px' }).observe(buyBlock);
    }

    if (stickyAdd && addButton && buyBlock) {
      stickyAdd.addEventListener('click', function () {
        buyBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
        addButton.click();
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-lesamis-product]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* El editor de temas reinyecta secciones: hay que re-inicializar */
  document.addEventListener('shopify:section:load', boot);
})();